module.exports = __webpack_public_path__ + "img/compare-4.7722f0a2.jpg";